/**
 * Gera um slug URL-seguro no estilo WordPress — suporta Português e qualquer
 * texto Latin-script com acentos/diacríticos.
 *
 * Etapas (espelha o `sanitize_title_with_dashes` do WordPress):
 *  1. NFD-decomposição → separa char-base do diacrítico (á → a + ́)
 *  2. Remove todas as marcas de combinação Unicode (cedilhas, til, acute…)
 *  3. Minúsculas
 *  4. & → "-e-" (português: "e")
 *  5. Substitui tudo que não seja a-z / 0-9 / espaço / hífen por espaço
 *  6. Trim
 *  7. Espaços/underscores → hífen
 *  8. Colapsa hífens consecutivos
 *  9. Remove hífens no início e no fim
 *
 * Exemplos:
 *   "Análise do Seguro"           → "analise-do-seguro"
 *   "Ação & Reação (2024)"        → "acao-e-reacao-2024"
 *   "TOP 10 Seguradoras!"         → "top-10-seguradoras"
 *   "Mercado Cripto: O Guia #1"   → "mercado-cripto-o-guia-1"
 */
export function slugifyText(value: unknown): string {
  if (value == null) return ''

  return String(value)
    .normalize('NFD') // decompõe: ã → a + ̃  |  ç → c + ̧  |  é → e + ́
    .replace(/\p{M}/gu, '') // remove marcas de combinação (diacríticos)
    .toLowerCase()
    .replace(/&/g, '-e-') // & → -e-
    .replace(/[^a-z0-9\s-]/g, ' ') // remove tudo que não seja alfanumérico, espaço ou hífen
    .trim()
    .replace(/[\s_]+/g, '-') // espaços / underscores → hífens
    .replace(/-+/g, '-') // colapsa hífens consecutivos
    .replace(/^-+|-+$/g, '') // remove hífens no início e no fim
}

/**
 * Wrapper compatível com o tipo `Slugify` do Payload CMS (campo `slugify` em `slugField()`).
 * O tipo `Slugify` não é re-exportado pelo pacote principal, por isso usa-se a assinatura
 * inline compatível: recebe `{ valueToSlugify, data, req }` e devolve uma string.
 */
export const payloadSlugify = ({
  valueToSlugify,
}: {
  valueToSlugify?: unknown
  data?: Record<string, unknown>
  req?: unknown
}): string => slugifyText(valueToSlugify)
